import { render, staticRenderFns } from "./index.vue?vue&type=template&id=111ad19f&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('111ad19f')) {
      api.createRecord('111ad19f', component.options)
    } else {
      api.reload('111ad19f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=111ad19f&", function () {
      api.rerender('111ad19f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/default/index.vue"
export default component.exports